import $ from 'jquery';
// JavaScript Document
// JavaScript Document
//This tool-tip is only used for very short Descriptions. 
function tinyTool(el, tipText, bgColor, textColor, width, speed, orientation){
	var $this = $(el); //store information about your the selected element
	var sheets = document.styleSheets; //get a list of all stylesheets
	$('.tinyToolTip').remove(); // if a tool-tip already exists on the page, remove it before appending the new one
	//build the new tool-tip
	var html = '<div class="tinyToolTip" style="z-index:20000; background-color:'+bgColor+'; border-color:'+bgColor+'; color:'+textColor+'; max-width:'+width+'px" onClick="event.cancelBubble = true">'+tipText;
		html+= '<div style="clear:both"></div>';
		html+= '</div>';
	$('body').append(html);//append it to the body
	
	//gather positioning details
	var position = $this.offset();
	var divWidth = $this.width();
	var divHeight = $this.height();
	var tipWidth = $('.tinyToolTip').width();
	var tipheight = $('.tinyToolTip').height();
	var windowHeight = $(window).innerHeight();
	var windowWidth = $(window).innerWidth();
	var windowTop = $(window).scrollTop();
	var bodyHeight = $('body').height();
	var paddingBottom = $this.css('padding-bottom').split('px');
	var paddingTop = $this.css('padding-top').split('px');
	var paddingLeft = $this.css('padding-left').split('px');
	paddingBottom = +paddingBottom[0];
	paddingTop = +paddingTop[0];
	paddingLeft = +paddingLeft[0];
	
	if((windowHeight + windowTop) < (position.top + paddingTop + paddingBottom + divHeight + tipheight + 15) || orientation === 'top'){
		//center tool-tip 70 pixels below the element then animate to 30 pixels below while increasing opacity to 1
		$('.tinyToolTip').addClass('tiny_top').css({top: (position.top - paddingTop - tipheight - 70), left: position.left + (divWidth/2) - (tipWidth/2) - 10 + paddingLeft});
		//console.log(divHeight);
		$('.tinyToolTip').animate({
			top: position.top - paddingTop - tipheight - 30,
			opacity:1
		},speed);
		var leftVal = (tipWidth/2) + 2;
	}else{
		//center tool-tip 70 pixels below the element then animate to 30 pixels below while increasing opacity to 1
		$('.tinyToolTip').addClass('tiny_bottom').css({top: (position.top + divHeight) + ((+paddingTop + +paddingBottom) + 70), left: position.left + (divWidth/2) - (tipWidth/2) - 10 + +paddingLeft});
		//console.log(divHeight);
		$('.tinyToolTip').animate({
			top: (position.top + divHeight) + ((+paddingTop + +paddingBottom) + 15),
			opacity:1
		},speed);
		var leftVal = (tipWidth/2) + 2;
	}
}
//create your plugin for the above function
$.fn.customTip = function(options){
	var tinyDef = $.extend({ //set your default values/options
		color: "#f1f1f1",
		backgroundColor: "#515151",
		text: "",
		maxWidth: 150,
		speed: 100,
		orientation: 'bottom',
		access: 'mouseenter'
	}, options );
	this.on(tinyDef.access,function(e){//run this code when mouse enters the element
		//if the title attribute does not exist use the default value
		e.cancelBubble = true;
		e.stopPropagation();
		if($(this).attr('data-content') === 'undefined' || $(this).attr('data-content') === undefined){
			var text = tinyDef.text;
		}else{
			var text = $(this).attr('data-content');
		}
		if($(this).attr('data-color') === 'undefined' || $(this).attr('data-color') === undefined){
			var color = tinyDef.color;
		}else{
			var color = $(this).attr('data-color');
		}
		if($(this).attr('data-bgColor') === 'undefined' || $(this).attr('data-bgColor') === undefined){
			var backgroundColor = tinyDef.backgroundColor;
		}else{
			var backgroundColor = $(this).attr('data-bgColor');
		}
		if($(this).attr('data-width') === 'undefined' || $(this).attr('data-width') === undefined){
			var width = tinyDef.maxWidth;
		}else{
			var width = $(this).attr('data-width');
		}
		//console.log(settings.text.length);
		try{
			if(text.length > 0){//if there is no text for the tool-tip cancel, otherwise call the tool-tip function
				//Call the function with parameters
				tinyTool(this, text, backgroundColor, color, width, tinyDef.speed, tinyDef.orientation);
			}
			if(tinyDef.access != 'mouseenter'){
				$('html, body').not('.tinyToolTip').one('click',function(){
					$('.tinyToolTip').clearQueue();
					$('.tinyToolTip').stop().remove();//remove the tool-tip	   
				});
			}
		}catch(e){
			//console.log(e);	
		}
	});
	if(tinyDef.access === 'mouseenter'){
		this.mouseleave(function(e){//when the mouse hovers away from the element, run this
			$('.tinyToolTip').clearQueue();
			$('.tinyToolTip').stop().remove();//remove the tool-tip
		});
	}
}


//New tool-tip Function
function modernToolTip(el, url, code, uniqueID, event){
	var $this = $(el);
	
	event.cancelBubble = true;
	event.stopPropagation();
	var sheets = document.styleSheets; //get a list of all stylesheets
	
	$this.click(function(e){
		e.cancelBubble = true;
		e.stopPropagation();
	});
	
	var html = code;
	$('body').append(html);
	var $tip = $('.toolTipHovered#'+uniqueID);
	$tip.children('#loadDiv').empty();
	if(url){
		$tip.children('#loadDiv').load(url);
	}
	
	var position = $this.offset();
	var divWidth = $this.width();
	var divHeight = $this.height();
	var tipWidth = $tip.width();
	var tipheight = $tip.height();
	var windowHeight = $(window).innerHeight();
	var windowWidth = $(window).innerWidth();
	var bodyHeight = $('body').height();
	var paddingTop = $this.css('padding-top').split('px');
	var paddingLeft = $this.css('padding-left').split('px');
	var paddingRight = $this.css('padding-right').split('px');
	paddingTop = +paddingTop[0];
	paddingLeft = +paddingLeft[0];
	paddingRight = +paddingRight[0];
	if((position.left + divWidth + tipWidth + 50 + (paddingLeft + paddingRight)) > windowWidth){
		var topVal = (divHeight/2);
		$tip.addClass('right');
		$tip.css({top: ((position.top) + paddingTop) + topVal - 10, left: (position.left - tipWidth) - 40});
	}else{
		var topVal = (divHeight/2);
		$tip.addClass('left');
		$tip.css({top: ((position.top) + paddingTop) + topVal - 10, left: position.left + divWidth + (paddingLeft + paddingRight) + 40});
	}
	
	return true;
}

//Create the Plugin for the new tool-tip
$.fn.clickTip = function(options){
	var settings = $.extend({ //set your default values/options
		color: "#666",
		backgroundColor: "#f1f1f1",
		headerTextColor: "#CCC",
		headerBGColor: "#666",
		includeHeader: false,
		headerText: '',
		url: '',
		text: "",
		source: 'title',
		width: '240px',
		height: 'auto',
		access: 'mouseenter',
		noClose: false
	}, options );
	this.on(settings.access,function(e){//run this code when the element is clicked
		//if the title attribute does not exist use the default value
		if($(this).attr('data-content') != 'undefined' && $(this).attr('data-content') != undefined){
			var text = $(this).attr('data-content');
		}else{
			var text =settings.text;
		}
		if($(this).attr('data-color') != 'undefined' && $(this).attr('data-color') != undefined){
			var color = $(this).attr('data-color');
		}else{
			var color = settings.color;
		}
		if($(this).attr('data-bgColor') != 'undefined' && $(this).attr('data-bgColor') != undefined){
			var backgroundColor = $(this).attr('data-bgColor');
		}else{
			var backgroundColor = settings.backgroundColor;
		}
		if($(this).attr('data-headerBGColor') != 'undefined' && $(this).attr('data-headerBGColor') != undefined){
			var headerBGColor = $(this).attr('data-headerBGColor');
		}else{
			var headerBGColor = settings.headerBGColor;
		}
		if($(this).attr('data-headerTColor') != 'undefined' && $(this).attr('data-headerTColor') != undefined){
			var headerTextColor = $(this).attr('data-headerTColor');
		}else{
			var headerTextColor = settings.headerTextColor;	
		}
		if($(this).attr('data-header') != 'undefined' || $(this).attr('data-header') != undefined){
			settings.includeHeader = true;
			var headerText = $(this).attr('data-header');
		}else if(settings.headerText.length > 0){
			settings.includeHeader = true;
			var headerText = settings.headerText;
		}else{
			settings.includeHeader = false;
			var headerBGColor = settings.backgroundColor;
		}
		
		
		if($(this).attr('data-url') === 'undefined' || $(this).attr('data-url') === undefined){
			var url = settings.url;
		}else{
			settings.includeHeader = true;
			var url = $(this).attr('data-url');
		}
		try{
			if(url.length > 0){
				settings.text = '';
			}
			var uniqueID = 'thisTip_'+Math.floor(Math.random()*1100000);
			var html = '<div class="toolTipHovered '+settings.noClose+'" id="'+uniqueID+'" style="z-index:1000; background-color:'+backgroundColor+'; border-color:'+headerBGColor+'; width:'+settings.width+'; height:'+settings.height+'" onClick="event.cancelBubble = true">';
			if(settings.includeHeader){
				html+= '<div style="height:auto; padding:8px 10px 10px; background-color:'+headerBGColor+'; border-radius: 4px 4px 0 0">';
				html+= '<h3 style="color:'+headerTextColor+'">'+headerText+'</h3>';
				html+= '</div>';
			}
			if(url.length > 0){
				html+= '<div id="loadDiv" style="width:100%; height: auto">';
				html+= '<div style="clear:both"></div>';
				html+= '</div>';
			}
			if(text.length > 0){
				html+= '<div style="height:auto; padding:10px; color:'+color+'">'+text;
				html+= '<div style="clear:both"></div>';
				html+= '</div>';
			}
			html+= '<div style="clear:both"></div>';
			html+= '</div>';
			if(!settings.noClose){
				$('.toolTipHovered').not('.true').remove();
			}
			//Call the function with parameters
			if(url.length === 0 && text.length === 0){}else{
				var request = modernToolTip(this, url, html, uniqueID, e);
			}
			
			if(settings.access != 'mouseenter' && !settings.noClose){
				$('html, body').not('.toolTipHovered').one('click',function(){
					$('.toolTipHovered').not('.true').clearQueue();
					$('.toolTipHovered').not('.true').stop().remove();//remove the tooltip	   
				});
			}
		}catch(e){
			//console.log(e);	
		}
	});
	if(settings.access === 'mouseenter'){
		this.mouseleave(function(e){//when the mouse hovers away from the element, run this
			$('.toolTipHovered').not('.true').clearQueue();
			$('.toolTipHovered').not('.true').stop().remove();//remove the tooltip
		});
	}
}

function wideMenus(el, url, code, e){
	try{
	var $this = $(el); //store information about your the selected element
	var sheets = document.styleSheets; //get a list of all stylesheets
	$('.menuTip').clearQueue();//clear anything that is in queue
	$('.menuTip').stop();//stop any previous action on elements with this class
	$('.menuTip').remove();//if a tool-tip already exists on the page, remove it before appending the new one
	var html = code;
	$this.append(html);//append it to the menu element
	$('.menuTip').load(url,function(){
		//gather positioning details
		var position = $this.offset();
		var divWidth = $this.width();
		var divHeight = $this.height();
		var tipWidth = $('.menuTip').width();
		var tipheight = $('.menuTip').height();
		var windowHeight = $(window).innerHeight();
		var windowWidth = $(window).innerWidth();
		
		//center tool-tip 70 pixels below the element then animate to 30 pixels below while increasing opacity to 1
		if((position.left + tipWidth + 20) > windowWidth){
			if(position.left < (tipWidth + 20)){
				var right = ((tipWidth + 20) - position.left);
				var leftVal = (divWidth/2) - 3 + (right - 5);
			}else{
				var right = 0;
				var leftVal = (divWidth/2) - 5;
			}
			
			$('.menuTip').css({top: (divHeight) + 50, right: -right});
			$('.menuTip').animate({
				top: (divHeight) + 10,
				opacity:1
			},200);
			
			//position the arrow of the tool-tip to center by creating and adding style information
			try{
				var stylesheetToInsert = document.createElement('style');  
				document.getElementsByTagName('body')[0].appendChild(stylesheetToInsert);
				var insertedStylesheet = document.styleSheets[document.styleSheets.length - 1];
				addCSSRule(insertedStylesheet,".menuTip:after", "right: "+leftVal+"px; left: inherit",insertedStylesheet.cssRules.length);
			}catch(e){
				// output any error that may come with disturbing the rest of the js on the page.
				//console.log(e);
			}
		}else{
			$('.menuTip').css({top: (divHeight) + 50, left:0});
			$('.menuTip').animate({
				top: (divHeight) + 10,
				opacity:1
			},200);
			var leftVal = (divWidth/2) - 5;
			//position the arrow of the tool-tip to center by creating and adding style information
			try{
				var stylesheetToInsert = document.createElement('style');  
				document.getElementsByTagName('body')[0].appendChild(stylesheetToInsert);
				var insertedStylesheet = document.styleSheets[document.styleSheets.length - 1];
				addCSSRule(insertedStylesheet,".menuTip:after", "left: "+leftVal+"px",insertedStylesheet.cssRules.length);
			}catch(e){
				// output any error that may come with disturbing the rest of the js on the page.
				//console.log(e);
			}
		}
	});
	}catch(e){
		// output any error that may come with disturbing the rest of the js on the page.
		//console.log(e);
	}
}

//Create the Plugin for the new menu tip
$.fn.homeMenu = function(options){
	var settings = $.extend({ //set your default values/options
		color: "#666666",
		backgroundColor: "#ffffff",
		url: '',
		onMenuLoad: function(){},
		width: '300px',
		height: 'auto',
		params: ''
	}, options );
	this.mouseenter(function(e){//run this code when the element is clicked
		var textValue;
		var headerValue;
		var url;
		var params;
		
		//if the data-params attribute exist, use it
		if($(this).attr('data-params') === 'undefined' || $(this).attr('data-params') === undefined){}else{
			settings.params = $(this).attr('data-params');
			//build the new tool-tip
			var html = '<div class="menuTip" style="z-index:20000; background-color:'+settings.backgroundColor+'; border-bottom-color:'+settings.backgroundColor+'; color:'+settings.color+';width:'+settings.width+';height:'+settings.height+'" onClick="event.cancelBubble = true">';
				html+= '<div style="clear:both"></div>';
				html+= '</div>';
			//Call the function with parameters
			url = settings.url+'?'+settings.params;
			wideMenus(this, url, html, e);
			/*if(request){
				this.bind('click', afterLoading);
				function afterLoading(){
					settings.onMenuLoad.call(this);
				}
			}*/
		}
	});
	this.mouseleave(function(e){//when the mouse hovers away from the element, run this
		$('.menuTip').clearQueue();//clear anything that is in queue on this item
		$('.menuTip').stop().remove();//stop and remove the tool-tip
	});
}
function addCSSRule(sheet, selector, rules, index) {
	try{
		if(sheet.insertRule) {
			sheet.insertRule(selector + "{" + rules + "}", index);
		}else{
			sheet.addRule(selector, rules, index);
		}
	}catch(e){
		//console.log(e);
	}
}

/*--- Slideshow Plugin Start ---*/

$.fn.slideshows = function(options){
	var slideshowOptions = $.extend({
		addLinks: '',
		width: '100%',
		height: 300,
		stopLength: 5000,
		resetShow: false
	}, options);
	if(slideshowOptions.resetShow){
		$(".slideNavigation").empty();
	}
	$('ul.slideshow').each(function(index, element) {
		var slideCount = $(this).children('li').length;
		var stopLength = $(this).attr('data-time') != undefined && $(this).attr('data-time') !== 'undefined' && $(this).attr('data-time') !== '' ? parseInt($(this).attr('data-time')) : slideshowOptions.stopLength;
		var navigation = $(this).attr('data-nav') != undefined && $(this).attr('data-nav') !== 'undefined' && $(this).attr('data-nav') !== '' && $(this).attr('data-nav') !== 'false' ? true : false;
		var clickNav = $(this).attr('data-clicknav') != undefined && $(this).attr('data-clicknav') !== 'undefined' && $(this).attr('data-clicknav') !== '' && $(this).attr('data-clicknav') !== 'false' ? true : false;
		var width = $(this).parent().width();
		$(this).attr('data-slideCount', slideCount);
		$(this).attr('data-index', index);
		if(navigation && clickNav){}else{
			if(navigation){
				$(this).parent().append('<div class="slideNavigation clearfix"></div>');
			}
			if(clickNav && slideCount > 1){
				$(this).parent().append('<div class="clickNav navLeft" id="clickNavLeft" onClick="changeSlide('+(slideCount - 1)+', '+this+')"><i class="glyphicon glyphicon-chevron-left"></i></div><div class="clickNav navRight" id="clickNavRight" onClick="changeSlide('+1+',  '+this+')"><i class="glyphicon glyphicon-chevron-right"></i></div>');
			}
		}
		
		$(this).not('ul.slideshow[data-slideCount="1"]').children('li').each(function(index, element) {
			$(this).attr('data-slide', index);
			if(index == 0){
				$(this).css({display: 'block', zIndex: 2});
			}else{
				$(this).css({display: 'none', zIndex: 0});
			}
			if(navigation && clickNav){}else{
				if(navigation){
					if(index == 0){
						$(this).parent().parent().children('.slideNavigation').append('<div class="slideNavLinks active" id="link_'+index+'" onClick="selectSlide('+index+', this)"></div>');
					}else{
						$(this).parent().parent().children('.slideNavigation').append('<div class="slideNavLinks" id="link_'+index+'" onClick="selectSlide('+index+', this)"></div>');
					}
				}
			}
		});
		if(slideshowOptions.resetShow){
			clearInterval(window['setTimer'+index]);
		}
		window['setTimer'+index] = setInterval(function(){
			startSlideshow(index)
		}, stopLength);
	});
	
}
function startSlideshow(index){
	var $this = $('ul.slideshow[data-index="'+index+'"]').not('ul.slideshow[data-slideCount="1"]');
	var slideCount = $this.children('li').length;
	var navigation = $this.attr('data-nav') != undefined && $this.attr('data-nav') !== 'undefined' && $this.attr('data-nav') !== '' && $this.attr('data-nav') !== 'false' ? true : false;
	var clickNav = $this.attr('data-clicknav') != undefined && $this.attr('data-clicknav') !== 'undefined' && $this.attr('data-clicknav') !== '' && $this.attr('data-clicknav') !== 'false' ? true : false;
	var widths = $this.parent().width();
	//$this.children('li').css({width: widths});
	var currentSlide = parseInt($this.children('li:visible').attr('data-slide'));
	if(currentSlide != (slideCount - 1)){
		$this.children('li[data-slide="'+(currentSlide + 1)+'"]').css({display: 'block', zIndex: 2, left: 0 + widths});
		if(navigation == true){
			$this.parent().children('.slideNavigation').children('#link_'+currentSlide).removeClass('active');
		}
		$this.animate({
			left: 0 - widths
		}, 400, function(){
			$this.children('li[data-slide="'+currentSlide+'"]').css({display: 'none', zIndex: 0});
			$this.css({left: 0});
			$this.children('li[data-slide="'+(currentSlide + 1)+'"]').css({left: 0});
			if(clickNav == true){
				$this.parent().children('#clickNavLeft').attr('onClick','changeSlide('+currentSlide+', '+this+')');
				if((currentSlide + 1) != (slideCount - 1)){
					$this.parent().children('#clickNavRight').attr('onClick','changeSlide('+(currentSlide + 2)+','+this+')');
				}else{
					$this.parent().children('#clickNavRight').attr('onClick','changeSlide('+0+', '+this+')');
				}
			}
		});
		if(navigation == true){
			$this.parent().children('.slideNavigation').children('#link_'+(currentSlide + 1)).addClass('active');
		}
	}else if(slideCount > 1){
		$this.children('li[data-slide="'+0+'"]').css({display: 'block', zIndex: 2, left: 0 + widths});
		if(navigation == true){
			$this.parent().children('.slideNavigation').children('#link_'+currentSlide).removeClass('active');
		}
		$this.animate({
			left: 0 - widths
		}, 400, function(){
			$this.children('li[data-slide="'+currentSlide+'"]').css({display: 'none', zIndex: 0});
			$this.css({left: 0});
			$this.children('li[data-slide="'+0+'"]').css({left: 0});
			if(clickNav == true){
				$this.parent().children('#clickNavLeft').attr('onClick','changeSlide('+(slideCount - 1)+', '+this+')');
				$this.parent().children('#clickNavRight').attr('onClick','changeSlide('+1+', '+this+')');
			}
		});
		if(navigation == true){
			$this.parent().children('.slideNavigation').children('#link_'+0).addClass('active');
		}
	}
}

function selectSlide(index, el){
	var $this = $(el).parent().parent().children('ul.slideshow').not('ul.slideshow[data-slideCount="1"]');
	var slideIndex = $this.attr('data-index');
	clearInterval(window['setTimer'+slideIndex]);
	var currentSlide = parseInt($this.children('li:visible').attr('data-slide'));
	var widths = $this.parent().width();
	$(el).parent().children('.slideNavLinks').removeClass('active');
	$(el).addClass('active');
	if(currentSlide !== index){
		$this.children('li[data-slide="'+index+'"]').css({display: 'block', zIndex: 2, left: 0 + widths});
		$this.animate({
			left: 0 - widths
		}, 400, function(){
			$this.children('li[data-slide="'+currentSlide+'"]').css({display: 'none', zIndex: 0});
			$this.css({left: 0});
			$this.children('li[data-slide="'+index+'"]').css({left: 0});
		});
		
	}
	
}

function changeSlide(index, el){
	var $this = $(el).parent().children('ul.slideshow').not('ul.slideshow[data-slideCount="1"]');
	var slideCount = $this.children('li').length;
	var slideIndex = $this.attr('data-index');
	clearInterval(window['setTimer'+slideIndex]);
	var currentSlide = parseInt($this.children('li:visible').attr('data-slide'));
	var widths = $this.parent().width();
	if(index > currentSlide && index != (slideCount - 1)){
		$this.children('li[data-slide="'+index+'"]').css({display: 'block', zIndex: 2, left: 0 + widths});
		$this.animate({
			left: 0 - widths
		}, 400, function(){
			$this.children('li[data-slide="'+currentSlide+'"]').css({display: 'none', zIndex: 0});
			$this.css({left: 0});
			$this.children('li[data-slide="'+index+'"]').css({left: 0});
			$this.parent().children('#clickNavLeft').attr('onClick','changeSlide('+(index - 1)+', this)');
			if(index != (slideCount - 1)){
				$this.parent().children('#clickNavRight').attr('onClick','changeSlide('+(index + 1)+', this)');
			}else{
				$this.parent().children('#clickNavRight').attr('onClick','changeSlide('+0+', this)');
			}
		});
	}else if(index === 0 && slideCount > 1){
		$this.children('li[data-slide="'+index+'"]').css({display: 'block', zIndex: 2, left: 0 + widths});
		$this.animate({
			left: 0 - widths
		}, 400, function(){
			$this.children('li[data-slide="'+currentSlide+'"]').css({display: 'none', zIndex: 0});
			$this.css({left: 0});
			$this.children('li[data-slide="'+index+'"]').css({left: 0});
			$this.parent().children('#clickNavLeft').attr('onClick','changeSlide('+(slideCount - 1)+', this)');
			$this.parent().children('#clickNavRight').attr('onClick','changeSlide('+1+', this)');
		});
	}else if(slideCount > 1){
		$this.children('li[data-slide="'+index+'"]').css({display: 'block', zIndex: 2, left: 0 + widths});
		$this.animate({
			left: 0 - widths
		}, 400, function(){
			$this.children('li[data-slide="'+currentSlide+'"]').css({display: 'none', zIndex: 0});
			$this.css({left: 0});
			$this.children('li[data-slide="'+index+'"]').css({left: 0});
			$this.parent().children('#clickNavLeft').attr('onClick','changeSlide('+(index - 1)+', this)');
			if(index != (slideCount - 1)){
				$this.parent().children('#clickNavRight').attr('onClick','changeSlide('+(index + 1)+', this)');
			}else{
				$this.parent().children('#clickNavRight').attr('onClick','changeSlide('+0+', this)');
			}
		});
	}
}



/*--- Slideshow Plugin End ---*/

/*--- Loader Tooltip Plugin Start ---*/
//This is used for tools such as the adding wishlists or viewing the Settings menu

$.fn.loadTip = function(options){
	var TipOptions = $.extend({
		url: ''
	}, options);
	
	$(this).each(function(index, element) {
		$(this).on('click', function(){
			var url = TipOptions.url == '' && typeof $(this).attr('data-url') != undefined && typeof $(this).attr('data-url') !== 'undefined' ? $(this).attr('data-url') : TipOptions.url;
			if(url.length > 0){
				var header = typeof $(this).attr('data-header') != undefined && typeof $(this).attr('data-header') !== 'undefined' ? $(this).attr('data-header') : '';
				var width = typeof $(this).attr('data-width') != undefined && typeof $(this).attr('data-width') !== 'undefined' ? $(this).attr('data-width') : 250;
				var align = typeof $(this).attr('data-align') != undefined && typeof $(this).attr('data-align') !== 'undefined' ? $(this).attr('data-align') : 'center';
				var position = $(this).offset();
				var height = $(this).height();
				var elWidth = $(this).width();
				var html = '<div class="loadTip_container" onClick="event.cancelBubble = true" id="Load'+index+'">';
					html+= '<div class="loadTip_header">'+header+'</div>';
					html+= '<div class="loadTip_body"></div>';
					html+= '<img src="/images/icons/loadTip_arrow.png" />';
					html+= '</div>';
				$('body').append(html);
				$('#Load'+index+' .loadTip_body').load(url, function(){
					$('body').one('click', function(){
						$('.loadTip_container').remove();
					});
				});
				if(align === 'center'){
					$('#Load'+index).css({
						width: width, 
						top: position.top + height + 10,
						left: position.left + (elWidth / 2) - (width / 2)
					});
				}else if(align === 'right'){
					$('#Load'+index).css({
						width: width, 
						top: position.top + height + 10,
						left: position.left + elWidth - width
					});
					$('.loadTip_container img').css({
						right: (elWidth / 2),
						left: 'auto',
						marginLeft: 'auto',
						marginRight: -16
					});
				}else if(align === 'left'){
					$('#Load'+index).css({
						width: width, 
						top: position.top + height + 10,
						left: position.left
					});
					$('.loadTip_container img').css({
						left: (elWidth / 2)
					});
				}
			}
		});
	});
}

export function slideShows(selector, options){
	$(selector).slideshows(options);
}

export function loadTip(selector, options){
	$(selector).loadTip(options);
}


/** WEBPACK FOOTER **
 ** ./scripts/jq_toolTips_sb.js
 **/